import Chart from "chart.js/auto";
import chartTrendline from 'chartjs-plugin-trendline';
import {legendSpacing, colorScheme, chartColors} from "./utilities";

Chart.register();
Chart.register(chartTrendline);

function generateLineChart(chartWrapper, chartData, chartSettings) {
	let colors = colorScheme(chartSettings.color_scheme);
	let data = chartData.datasets;
	let datasets = data.map((item, index) => {
		let colorKey = item.label.toLowerCase();
		let legendColors = chartColors(chartSettings.chart_colors, data.length);
		let backgroundColor = legendColors[colorKey] || legendColors[Object.keys(legendColors)[index % Object.keys(legendColors).length]];
		let borderColor = legendColors[colorKey] || legendColors[Object.keys(legendColors)[index % Object.keys(legendColors).length]];
		let trendline = null;

		if (chartSettings.trendline) {
			trendline = {
				colorMin: '#FF0000',
				colorMax: '#FF0000',
				lineStyle: "dotted",
				width: 1
			}
		}

		return {
			label: item.label,
			data: item.data,
			fill: chartSettings.fill,
			backgroundColor: backgroundColor,
			borderColor: borderColor,
			tension: 0.1,
			pointHitRadius: 3,
			trendlineLinear: trendline,
		};
	});

	Chart.defaults.color = colors.labels;
	Chart.defaults.borderColor = colors.grid;

	new Chart(chartWrapper, {
		type: 'line',
		data: {
			labels: chartData.labels,
			datasets: datasets,
		},
		plugins: [legendSpacing],
		options: {
			indexAxis: 'x',
			responsive: true,
			maintainAspectRatio: false,
			elements: {
				point: {
					radius: 0.5,
				},
				line: {
					borderWidth: 1,
				},
			},
			plugins: {
				title: {
					display: true,
					text: chartData.title,
					color: colors.labels,
					align: 'start',
					font: {
						size: 16,
						weight: 'bold'
					},
				},
				legend: {
					display: datasets.length > 1,
					labels: {
						boxWidth: 12,
						boxHeight: 12,
						useBorderRadius: true,
						borderRadius: 6,
						padding: 10,
						color: colors.labels,
					},
				},
				datalabels: {
					display: false,
				}
			},
			scales: {
				x: {
					grid: {
						display: true,
						drawOnChartArea: false,
						color: colors.grid,
					},
					title: {
						display: !!chartSettings.x_axis_title,
						text: chartSettings.x_axis_title,
						font: {
							size: 14,
						}
					},
					ticks: {
						maxTicksLimit: 10,
						maxRotation: 0,
						padding: 10,
						autoSkipPadding: 15,
						labelOffset: 15,
						font: {
							size: 11,
						},
					}
				},
				y: {
					grid: {
						color: colors.grid,
					},
					title: {
						display: !!chartSettings.y_axis_title,
						text: chartSettings.y_axis_title,
						font: {
							size: 14,
						}
					},
					ticks: {
						display: true,
						autoSkip: true,
						font: {
							size: 11,
						},
					}
				}
			},
		}
	});
}

export { generateLineChart };
